import React, { useState } from 'react'
import { Link } from "react-router-dom";
import WhatsappIcon from '../../pages/WhatsappIcon';
import Footer from '../../component/layout/Footer';
import emailjs from "@emailjs/browser";




const ContactUs = () => {

    const [name, setName] = useState("");
    const [mail, setmail] = useState("");
    const [massages, setMassages] = useState("");
    const [number, setNumber] = useState("");
    const [state, setState] = useState("");
    const [subject, setSubject] = useState("");
    const [city, setCity] = useState("");

    const nameChange = (e) => {
        const value = e.target.value;
        setName(value);
    };
    const stateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };
    const cityChange = (e) => {
        const value = e.target.value;
        setCity(value);
    };
    const subjectChange = (e) => {
        const value = e.target.value;
        setSubject(value);
    };
    const numberChange = (e) => {
        const value = e.target.value;
        setNumber(value);
    };

    const mailChange = (e) => {
        const value = e.target.value;
        setmail(value);
    };
    const massagesChange = (e) => {
        const value = e.target.value;
        setMassages(value);
    };


    const sendEmail = (e) => {
        e.preventDefault();
        emailjs
            .sendForm(

                "service_85vncqh",
                "template_jutx8hd",
                "#myForm",
                "dphUMCkFYP0BZruxu"
            )
            .then(
                function (response) {
                    console.log("SUCCESS!", response.status, response.text);
                    if (response.text === "OK") {
                        setName("");
                        setmail("");
                        setMassages("");
                        setNumber("");
                        setState("");
                        setSubject("");
                        setCity("");

                    }
                },
                function (error) {
                    console.log("FAILED...", error);
                }
            );
    };

    return (
        <>

            <div className="container-fluid contact overflow-hidden">
                <div className="container py-5">
                    <div className="row g-5 mb-5">
                        <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s" style={{ visibility: 'visible', animationDelay: '0.1s', animationName: 'fadeInLeft' }}>
                            <div className="sub-style">
                                <h5 className="sub-title text-primary pe-3">Quick Contact</h5>
                            </div>
                            <h1 className="display-5 mb-4">Have Questions?</h1>
                            {/* <p className="mb-5">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quaerat totam deserunt tempora. Tempore neque necessitatibus corporis error earum sint quae?</p> */}
                            <div className="d-flex border-bottom mb-4 pb-4">
                                <i className="fas fa-map-marked-alt fa-4x text-primary bg-light p-3 rounded" />
                                <div className="ps-3">
                                    <h5>Location</h5>
                                    <p> <a href='https://share.google/I6OxTjR8FurkQVoHM' target="_blank">  Railway Station, Station Rd, Railway Colony, Satna, Madhya Pradesh 485001</a></p>
                                </div>
                            </div>
                            <div className="row g-3">
                                <div className="col-xl-6">
                                    <div className="d-flex">
                                        <i className="fas fa-tty fa-3x text-primary" />
                                        <div className="ps-3">
                                            <h5 className="mb-3">Quick Contact</h5>
                                            <div className="mb-3">
                                                <h6 className="mb-0">Phone:</h6>
                                                <a href="tel:+91 7389578180" className="fs-5 text-primary">+91 7389578180</a>
                                            </div>
                                            <div className="mb-3">
                                                <h6 className="mb-0">Email:</h6>
                                                <a href="mailto:sp.neelendra100@gmail.com" className="fs-5 text-primary">sp.neelendra100@gmail.com</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xl-6">
                                    <div className="d-flex">
                                        <i className="fas fa-clone fa-3x text-primary" />
                                        <div className="ps-3">
                                            <h5 className="mb-3">Opening Hrs</h5>
                                            <div className="mb-3">
                                                <h6 className="mb-0">24 Hrs Booking Open</h6>
                                                {/* <a to="#" className="fs-5 text-primary">09.00 am to 07.00 pm</a> */}
                                            </div>
                                            {/* <div className="mb-3">
                                                <h6 className="mb-0">Satday:</h6>
                                                <a to="#" className="fs-5 text-primary">10.00 am to 05.00 pm</a>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="d-flex align-items-center pt-3">
                                <div className="me-4">
                                    <div className="bg-light d-flex align-items-center justify-content-center" style={{ width: 90, height: 90, borderRadius: 10 }}><i className="fas fa-share fa-3x text-primary" /></div>
                                </div>
                                <div className="d-flex">
                                    <a target="_blank" className="btn btn-secondary border-secondary mx-2 p-0" href='https://www.instagram.com/shiv_travels_8180?igsh=M2YzcHNzdWYwY29j'>instagram <i className="fas fa-chevron-circle-right" /></a>
                                    <a className="btn btn-secondary border-secondary me-2 p-0" to>facebook <i className="fas fa-chevron-circle-right" /></a>
                                    {/* <a className="btn btn-secondary border-secondary mx-2 p-0" to>twitter <i className="fas fa-chevron-circle-right" /></a> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 wow fadeInRight" data-wow-delay="0.3" style={{ visibility: 'visible', animationName: 'fadeInRight' }}>
                            <div className="sub-style">
                                <h5 className="sub-title text-primary pe-3">Let’s Connect</h5>
                            </div>
                            <h1 className="display-5 mb-4">Send Your Message</h1>
                            {/* <p className="mb-3">The contact form is currently inactive. Get a functional and working contact form with Ajax &amp; PHP in a few minutes. Just copy and paste the files, add a little code and you're done. <a className="text-primary fw-bold" to="https://htmlcodex.com/contact-form">Download Now</a>.</p> */}
                            <form method="post" onSubmit={sendEmail} id="myForm">
                                <div className="row g-4">
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="text" className="form-control" placeholder="Your Name"
                                                name="from_name"
                                                onChange={(e) => nameChange(e)}
                                                required
                                                value={name}
                                            />
                                            <label htmlFor="name">Your Name</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-xl-6">
                                        <div className="form-floating">
                                            <input type="email" className="form-control" placeholder="Your Email"
                                                id="email"
                                                name='email'
                                                onChange={(e) => mailChange(e)}
                                                value={mail}
                                                required
                                            />
                                            <label htmlFor="email">Your Email</label>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-xl-12">
                                        <div className="form-floating">
                                            <input type="phone" className="form-control" placeholder="Phone"
                                                id="phone"
                                                name='phone'
                                                onChange={(e) => numberChange(e)}
                                                value={number}
                                                required
                                            />
                                            <label htmlFor="phone">Your Phone</label>
                                        </div>
                                    </div>


                                    <div className="col-12">
                                        <div className="form-floating">
                                            <textarea className="form-control" placeholder="Leave a message here" style={{ height: 160 }}
                                                onChange={(e) => massagesChange(e)}
                                                name='massage'
                                                value={massages}
                                                required
                                            />
                                            <label htmlFor="message">Message</label>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        {/* <button className="btn btn-primary w-100 py-3">Send Message</button> */}
                                        <button type="submit" value="submit" name='submit' className="btn btn-primary w-100 py-3" style={{ background: "#1774ba", color: "white", fontSize: "18px" }}>Send Message </button>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default ContactUs